import React, { useState } from 'react';
import {
    IonButton,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonIcon,
    IonText,
    useIonToast
} from '@ionic/react';
import { logoGoogle, logoFacebook } from 'ionicons/icons';
import { AuthenticationState, useAuth } from '../contexts/AuthContext';
import { config } from '../../../config';

const ENABLE_SOCIAL_LOGIN = config.enableSocialLogin;

export const SocialLogin: React.FC = () => {
    const [error, setError] = useState<string | null>(null);
    const { loginWithSocial, authState } = useAuth();
    const [present] = useIonToast();

    // Don't render if social login is disabled
    if (!ENABLE_SOCIAL_LOGIN) {
        return null;
    }

    const handleGoogleLogin = async () => {
        try {
            await loginWithSocial('google');
            present({
                message: 'Successfully logged in with Google',
                duration: 3000,
                position: 'bottom',
                color: 'success'
            });
        } catch (err) {
            const message = err instanceof Error ? err.message : 'Failed to login with Google';
            setError(message);
            present({
                message,
                duration: 3000,
                position: 'bottom',
                color: 'danger'
            });
        }
    };

    const handleFacebookLogin = async () => {
        try {
            await loginWithSocial('facebook');
            present({
                message: 'Successfully logged in with Facebook',
                duration: 3000,
                position: 'bottom',
                color: 'success'
            });
        } catch (err) {
            const message = err instanceof Error ? err.message : 'Failed to login with Facebook';
            setError(message);
            present({
                message,
                duration: 3000,
                position: 'bottom',
                color: 'danger'
            });
        }
    };

    return (
        <IonCard>
            <IonCardHeader>
                <IonCardTitle>Sign in with Social Media</IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
                {error && (
                    <IonText color="danger">
                        <p className="ion-padding-start">{error}</p>
                    </IonText>
                )}

                <div className="ion-padding-top">
                    <IonButton
                        expand="block"
                        disabled={authState === AuthenticationState.INITIALIZING}
                        onClick={handleGoogleLogin}
                        color="light"
                    >
                        <IonIcon slot="start" icon={logoGoogle} />
                        Continue with Google
                    </IonButton>

                    <IonButton
                        expand="block"
                        disabled={authState === AuthenticationState.INITIALIZING}
                        onClick={handleFacebookLogin}
                        color="primary"
                    >
                        <IonIcon slot="start" icon={logoFacebook} />
                        Continue with Facebook
                    </IonButton>
                </div>
            </IonCardContent>
        </IonCard>
    );
}; 